import React from 'react'
import {
  PixelCurrency,
  PixelDate,
  PixelTable,
  PixelTag,
  PixelText,
  Section,
  SectionContent,
} from 'pixel-base'

const columns = [
  {
    dataKey: 'invoice_id',
    name: 'Invoice #',
    sortable: true,
    selector: (row) => row.invoice_id || '--',
  },
  {
    dataKey: 'payment_method_type',
    name: 'Paid Via',
    width: '20%',
    sortable: true,
    selector: (row) => (
      <PixelText mulitline>
        {row.stripe_payment_id ? 'Stripe' : 'Manually Recorded'}
      </PixelText>
    ),
  },
  {
    dataKey: 'payment_gateway_name',
    name: 'Receiving Account',
    sortable: true,
    selector: (row) => row.payment_gateway_name || '--',
  },
  {
    dataKey: 'amount',
    name: 'Amount',
    sortable: true,
    selector: (row) =>
      <PixelCurrency value={row.amount} currency={'USD'} /> || '--',
  },
  {
    dataKey: 'financial_status',
    name: 'Status',
    sortable: true,
    selector: (row) =>
      <PixelTag className="success">{row.financial_status}</PixelTag> || '--',
  },
  {
    dataKey: 'created_at',
    name: 'Date',
    sortable: true,
    selector: (row) => (
      <PixelDate format={'pixelStandard'} value={row.created_at} />
    ),
  },
]

const PaymentHistory = (props) => {
  const { customer } = props

  return (
    <>
      <Section>
        <SectionContent>
          <PixelTable
            columns={columns}
            data={customer.transactions}
            progressPending={false}
          />
        </SectionContent>
      </Section>
    </>
  )
}

export default PaymentHistory
